const PickerSpinner = () => {
  return (
    <div className="input-picker-load d-flex justify-content-center align-items-center">
      <div className="bouncing-loader ">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default PickerSpinner;
